import NoPermission from '@/src/components/NoPermission';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Tabs } from 'antd';
import React, { memo, useMemo } from 'react';
import GlobalButton from '../../components/Antd/Button/Button';
import DropDown from '../../components/Antd/DropDown/DropDown';
import css from './ListPageLayout.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const { TabPane } = Tabs;
interface IProps {
  children?;
  title?;
  exportFun?;
  importFun?;
  addFun?;
  addText?;
  tabsConfig?;
  tabChange?;
  addButtonOverlay?;
  activeKey?;
  hideTop?;
  className?: string;
  exportComp?;
  tabBarStyle?;
  containerClassName?;
  disableAdd?: boolean;
  disableExport?: boolean;
  disableImport?: boolean;
  noPermission?: boolean;
}
const ListPageLayout = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    title,
    exportFun,
    importFun,
    addFun,
    addText,
    tabsConfig,
    tabChange,
    addButtonOverlay,
    activeKey,
    hideTop,
    className,
    exportComp,
    tabBarStyle,
    containerClassName,
    disableAdd,
    disableExport,
    disableImport,
    noPermission,
  } = props;
  const { children } = props;
  const tabPaneRender = useMemo(
    () =>
      tabsConfig &&
      tabsConfig.map((i) => <TabPane tab={i.name} key={i.key}></TabPane>),
    [tabsConfig, children],
  );
  return (
    <div className={`${css.listPageLayout} ${className}`}>
      {!hideTop && (
        <div className={css.layoutTop}>
          <div className={css.layoutTitle}>{title}</div>
          <div className={css.layoutRight}>
            {exportComp ||
              (exportFun && (
                <GlobalButton
                  type='text'
                  className={css.layoutRightBtn}
                  onClick={exportFun}
                  icon={<UploadOutlined />}
                  disabled={disableExport}>
                  {getI18n('general.export')}
                </GlobalButton>
              ))}
            {importFun && (
              <GlobalButton
                type='text'
                className={css.layoutRightBtn}
                onClick={importFun}
                icon={<DownloadOutlined />}
                disabled={disableImport}>
                {getI18n('general.import')}
              </GlobalButton>
            )}
            {addButtonOverlay ? (
              <DropDown
                className={css.dropDown}
                overlay={addButtonOverlay}
                trigger={['click']}
                disabled={disableAdd}>
                {addText && addFun && (
                  <GlobalButton className={css.layoutRightBtn} type='primary'>
                    {addText}
                  </GlobalButton>
                )}
              </DropDown>
            ) : (
              addText &&
              addFun && (
                <GlobalButton
                  className={css.layoutRightBtn}
                  onClick={addFun}
                  type='primary'
                  disabled={disableAdd}>
                  {addText}
                </GlobalButton>
              )
            )}
          </div>
        </div>
      )}
      {noPermission ? (
        <NoPermission />
      ) : (
        <div className={`${css.layoutContain} ${containerClassName || ''}`}>
          {tabsConfig && (
            <Tabs
              {...(activeKey
                ? { activeKey }
                : { defaultActiveKey: tabsConfig[0].key })}
              size={'large'}
              onChange={tabChange}
              tabBarStyle={tabBarStyle}>
              {tabPaneRender}
            </Tabs>
          )}
          <div className={css.tableChild}>{children}</div>
        </div>
      )}
      <div></div>
    </div>
  );
};
export default memo(ListPageLayout);
